import { Action } from '@ngrx/store';
import { PageHeaderStateInterface } from './page-header.model';

export const COUNTDOWN_TIMEOUT = '[PAGE HEADER] Countdown timeout';
export const UPDATE_FILTER_BAR_VISIBILITY = '[PAGE HEADER] Update filter bar visibility';
export const UPDATE_PAGE_HEADER_BUTTONS_VISIBILITY = '[PAGE HEADER] Update page header buttons visibility';
export const RESET_STORE_TO_DEFAULT = '[PAGE HEADER] Reset Store To Default';

export class UpdateFilterBarVisibility implements Action {
  readonly type = UPDATE_FILTER_BAR_VISIBILITY;

  constructor(public isVisible: boolean) {}
}

export class UpdatePageHeaderButtonsVisibility implements Action {
  readonly type = UPDATE_PAGE_HEADER_BUTTONS_VISIBILITY;

  constructor(public isPageHeaderButtonsVisible: Partial<PageHeaderStateInterface>) {}
}

export class ResetStoreToDefault implements Action {
  readonly type = RESET_STORE_TO_DEFAULT;
}

export type PageHeaderActions =
  | UpdateFilterBarVisibility
  | ResetStoreToDefault
  | UpdatePageHeaderButtonsVisibility;
